<template>
  <q-dialog
    v-model="dialog"
    persistent
    maximized
    transition-show="slide-up"
    transition-hide="slide-down"
  >
    <q-card class="iframe-dialog">
      <q-card-section class="iframe-dialog__header">
        <div class="text-h6" v-if="title">
          <div v-html="title" />
        </div>
        <q-btn
          round
          flat
          unelevated
          no-caps
          icon="close"
          color="secondary"
          @click.native="close"
        />
      </q-card-section>

      <q-card-section>
        <iframe class="iframe-dialog__iframe" :src="url" width="100%"></iframe>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  props: {
    open: Boolean,
    title: String,
    url: String,
  },

  methods: {
    close() {
      this.dialog = false;
    },
  },
  computed: {
    dialog: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("update:open", value);
      },
    },
  },
};
</script>

<style lang="scss">
.iframe-dialog {
  width: 100%;
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 65px;
    padding: 12px 15px;
    border-bottom: 0.5px solid #ececec;
    span {
      font-weight: 700;
    }
  }
  &__iframe {
    border: 0;
    height: 100%;
    min-height: 85vh;
    overflow: hidden;
  }
}
</style>
